import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { WholesalerUnableToTransferDevicesExistPipe } from './wholesaler-unable-to-transfer-devices-exist.pipe';
import { FilterOutSelectedEnclosuresPipe } from './filter-out-selected-enclosures.pipe';
import { FilterOutSelectedItemsPipe } from './filter-out-selected-items.pipe';
import { WholesalerUnableToTransferPipe } from './wholesaler-unable-to-transfer.pipe';

@Pipe({
    name: 'wholesalerUnableToTransferProjectDevicesExist',
    standalone: false
})
export class WholesalerUnableToTransferProjectDevicesExistPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[],
            bomProjectAccessories: IBomModel[],
            selectedProjectAccessories: number[],
            selectedEnclosures: number[]): boolean {
    const filterSelectedProjectBomItems = new FilterOutSelectedItemsPipe()
      .transform(bomProjectAccessories, selectedProjectAccessories, 'id');
    const unableProjectBomTransferToWholesalerDevicesExist = new WholesalerUnableToTransferPipe()
      .transform(filterSelectedProjectBomItems)?.length > 0;

    return unableProjectBomTransferToWholesalerDevicesExist || new WholesalerUnableToTransferDevicesExistPipe().transform(
      new FilterOutSelectedEnclosuresPipe().transform(bomModels, selectedEnclosures),
      new FilterOutSelectedEnclosuresPipe().transform(bomModelsAccessories, selectedEnclosures),
      selectedItems, selectedItemsAccessories);
  }

}
